// extracted by mini-css-extract-plugin
module.exports = {"inputDate":"InputDate_inputDate__g4G1w"};